import React from 'react';
import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormTextField from 'components/ui/form/FormTextField';
import useFormSubmit from 'hooks/useFormSubmit';

const validationSchema = yup.object({
  name: yup
    .string()
    .min(3, { label: 'object.validation.nameMin', value: 3 })
    .required('object.validation.name'),
  chat_id: yup.string().required('object.validation.chatId'),
});

const ChatAddModal = ({ open, setOpen, refetch }) => {
  const { t } = useTranslation();
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      name: '',
      chat_id: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      submit(
        { type: 'post', contentType: 'formData' },
        values,
        '/admin/telegram/chatadd',
        values.name,
        false,
        handleFinish
      );
    },
  });

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };
  const handleFinish = () => {
    handleClose();
    refetch?.();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!shadow-none !base-border',
      }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='text-center bg-gray-100 !`mb-2'
      >
        <span className='pr-5'>{t('common.button.addNew')}</span>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormTextField
                delay={0.1}
                label={t('common.fields.simpleName')}
                fieldName='name'
                formik={formik}
              />
            </Grid>

            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormTextField
                delay={0.4}
                label={t('common.fields.chatId')}
                fieldName='chat_id'
                formik={formik}
              />
            </Grid>

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.4}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(ChatAddModal);
